<template>
  <div class="bind-olduser">
    <el-form
      :model="userForm"
      :rules="userRules"
      ref="userForm"
      class="register-from"
      @submit.native.prevent
    >
      <el-form-item prop="phone">
        <el-input
          v-model="userForm.phone"
          placeholder="请输入手机号或邮箱"
          @focus="phoneFocus"
         
        ></el-input>
      </el-form-item>

      <el-form-item prop="password" class="pwd-item">
        <el-input
          :type="passwordFlag"
          v-model="userForm.password"
          placeholder="请输入已有账号登录密码"
          @focus="clearVerify('userForm', 'password')"
          :maxlength="18"
          @change="pwdError = false"
          autocomplete="new-password"
        ></el-input>
        <i
          :class="['open-pwd', passwordFlag == 'password' ? 'icon1' : 'icon2']"
          @click="openPwd()"
        ></i>
      </el-form-item>
    </el-form>
    <div class="btn" @click="bindAccount" @keyup.enter="(e)=>keyDown(e)">
      {{ registerName }}
    </div>

    <p @click="forgetPassword">忘记密码</p>
  </div>
</template>

<script>
import { bindAccount } from "@/../api";
import { mapState, mapMutations } from "vuex";
import { zhugeTrack, jumpAfterLogin } from "@/utils/utils";
export default {
  name: "",
  props: ["referUrl", "codeLogin","oldPhone"],
  data() {
    return {
      passwordFlag: "password",
      registerName: "绑定并登录",
      pwdError: false,
      pawErrMsg: "",

      userForm: {
        phone: "",
        password: "",
      },
      userRules: {
        phone: [
          { required: true, message: "请输入手机号或邮箱!", trigger: "blur" },
          { validator: this.userValidate, trigger: "blur" },
        ],

        password: [
          { required: true, message: "请输入已有账号登录密码", trigger: "blur" },
          { validator: this.passwordValidator },
        ],
      },
    };
  },
  watch:{
    "oldPhone":{
      handler(val){
          if(val){
            this.userForm.phone = val
          }else{
            this.userForm.phone = ""
          }
      },
      deep:true,
      immediate:true
    }
  },
  computed: {
    ...mapState(["isToastshow", "message", "manyloginToast",]),
  },
    mounted(){
    window.addEventListener('keydown',this.keyDown)
  },
  destroyed(){
    window.removeEventListener('keydown',this.keyDown,false)
  },
  methods: {
    ...mapMutations(["toastshow", "toastHidden", "manyLoginToastshow"]),
    keyDown(e){
      if((e.keyCode==13||e.keyCode==100) ){

        this.bindAccount(e)
      }
    },
    userValidate(rule, value, callback) {
      // 邮箱和手机号 校验
      var emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w{2,})*\.\w{2,}([-.]\w{2,})*$/;
      var talReg = /^1\d{10}$/;
      if (value) {
        if (value.indexOf("@") != -1) {
          // 邮箱
          if (!emailReg.test(value)) {
            return callback(new Error("账号格式不正确!"));
          } else {
            callback();
          }
        } else {
          if (!talReg.test(value)) {
            return callback(new Error("账号格式不正确!"));
          } else {
            callback();
          }
        }
      } else {
        return callback(new Error("请输入手机号或邮箱!"));
      }
    },
    show(message = "默认", duration = 3000) {
      this.toastshow(message);
      
         const toastTimer= setTimeout(() => {
       this.toastHidden();
        clearTimeout(toastTimer)
      }, duration);
    },
    

    // 密码校验
    passwordValidator(rule, value, callback) {
      if (this.pwdError) {
        return callback(
          new Error("请输入正确密码，连续输入错误，账号将被锁定")
        );
      } else {
        callback();
      }
    },

    // 忘记密码
    forgetPassword() {
      this.$router.push({
        name: "reset-pass",
        query: {
          refer: this.referUrl ? this.referUrl : undefined,
          codeLogin: this.codeLogin ? this.codeLogin : undefined,
        },
      });
      zhugeTrack("点击_忘记密码",{
        终端:"Web"
      });
    },

    // 显示、隐藏密码
    openPwd() {
      if (this.passwordFlag == "password") {
        this.passwordFlag = "text";
      } else {
        this.passwordFlag = "password";
      }
    },

    // 清除手机验证
    phoneFocus() {
      this.clearVerify("userForm", "phone");
      this.phoneHas = false;
    },

    // 注册验证码登录
    bindAccount() {
      if (this.registerName != "绑定并登录") {
        return;
      }

     

      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          let did = zhuge.getDid();
          let sid = zhuge.getSid();
          let bindParams = {
            account: this.userForm.phone,
            password: this.userForm.password,
            additional: did + "@" + sid,
           rememberme: "1",
            wechatLoginVo: this.$route.query,
          };
          this.registerName = "绑定中...";
          bindAccount(bindParams).then((res) => {
            if (res.data.code == 200) {
              localStorage.removeItem(this.userForm.phone);
              // 注册成功后登录
              // let loginParams = {
              //   username: this.userForm.phone,
              //   password: this.userForm.password,
              //   additional: did + "@" + sid,
              //   remeberme: this.remeberme,
              // };
              // this.registerName = "登录中...";
              // userLogin(loginParams).then((res) => {
           
              //   let result = res.data;
              //   if (result.status == 200) {
              // 登录成功后的跳转
              jumpAfterLogin(this.referUrl);
              //   } else {
              //     this.show("绑定失败");
              //     comPop(result.errorMessage);
              //   }
              this.registerName = "绑定并登录";
              // });
              zhugeTrack("Web_绑定并登录成功");
            } else if (res.data.code == 401) {
              this.pwdError = true;
              this.$refs["userForm"].validateField("password");
              
              this.pwdError = true;
              this.pawErrMsg = "请输入正确密码，连续输入错误，账号将被锁定";
              this.registerName = "绑定并登录";
            } else if (res.data.code == 10000) {
              this.show(res.data.developerMsg);
              this.registerName = "绑定并登录";
            }else if (res.data.code == 423) {
                this.manyLoginToastshow();
                this.registerName = "绑定并登录";
             }  else {
              this.show("绑定失败");
              this.registerName = "绑定并登录";
            }
          });
          zhugeTrack("Web_点击绑定");
        }
      });
    },
    // 清除单个表单项验证
    clearVerify(refName, item) {
      this.$refs[refName].clearValidate(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.bind-olduser {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: 100%;
  align-content: flex-start;
  .code-item {
    position: relative;
    ::v-deep .el-form-item__content {
      display: flex;
    }
    ::v-deep .el-input {
      display: flex;
      width: 240px;
      .el-input__inner {
        width: 240px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #e5e6eb;
        overflow: hidden;
        line-height: 40px;
      }
    }
    .get-code {
      width: 112px;
      height: 40px;
      background: #e8f3ff;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      text-align: center;
      margin-left: 16px;
      cursor: pointer;
      &:hover {
        color: #165dff;
      }
    }
  }
  .pwd-item {
    position: relative;

    .open-pwd {
      width: 14px;
      height: 14px;
      position: absolute;
      cursor: pointer;
      top: 50%;
      right: 19px;
      transform: translateY(-50%);
      opacity: 0.6;
      &:hover {
        opacity: 1;
      }
      i {
        line-height: 14px;
      }
    }
    .icon1 {
      background: url("../../assets/login/icon／preview-close\(2\).png");
      background-size: 100% 100%;
      opacity: 1;
      width: 16px;
      height: 16px;
      background-size: cover;
    }
    .icon2 {
      background: url("../../assets/login/icon／preview-open.png");
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
      background-size: cover;
      opacity: 1;
    }
  }

  .btn {
    width: 368px;
    height: 44px;
    border-radius: 4px;
    margin-top: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    letter-spacing: 0;
    cursor: pointer;
    border: none;
    outline: none;
    text-align: center;
    line-height: 44px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &:hover {
      background-color: #4080ff;
    }
  }
  .disabled {
    background: #ccc !important;
    cursor: auto;
    &:hover {
      background: #ccc !important;
    }
  }
  p {
    width: 100%;
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 22px;
    text-align: center;
    margin-top: 108px;
    cursor: pointer;
    &:hover {
      color: #165dff;
    }
  }
}
</style>
